import type { ColDef, IRowNode } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import { VENDER_DATE_FORMAT } from '~/constants';

import type { TypeVenderSupplier } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 테이블
 */
const getVenderSupplierColumnDefs = ({
  onClickViewDetail,
}: {
  onClickViewDetail: (node: IRowNode<TypeVenderSupplier>) => Promise<void>;
}) => {
  const columnDefs: ColDef<TypeVenderSupplier>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'ownerSupplierName',
      headerName: '공급사명',
      width: 180,
    },
    {
      field: 'ownerSupplierCode',
      headerName: '공급사코드',
      width: 120,
    },
    {
      field: 'createdAt',
      headerName: '등록일',
      width: 100,
      valueFormatter: ({ value }: { value: string }) => formatDate(value, VENDER_DATE_FORMAT.DATE) ?? '-',
    },
    {
      field: 'modifiedAt',
      headerName: '수정일',
      width: 100,
      valueFormatter: ({ value }: { value: string }) => formatDate(value, VENDER_DATE_FORMAT.DATE) ?? '-',
    },
    {
      field: 'useStatus',
      headerName: '사용여부',
      width: 80,
      valueFormatter: ({ value }: { value: 'Y' | 'N' }) => (value === 'Y' ? '사용' : '사용안함'),
    },
    {
      headerName: '',
      flex: 1,
      cellRenderer: TextButtonCell,
      cellRendererParams: {
        children: '상세보기',
        showDashIfNoValue: false,
        onClick: (node: IRowNode<TypeVenderSupplier>) => onClickViewDetail(node),
      },
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ];

  return { columnDefs };
};

export default getVenderSupplierColumnDefs;
